"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivityRulesEngineExtraFacts = exports.getRulesEngineDPIAnswers = exports.getActivityDatesMetadata = void 0;
const dateConstants_1 = require("./dateConstants");
const datetime_1 = require("./datetime");
const validation_1 = require("./types/validation");
// Task dates correspond to:
// firstAvailableDate: TaskResult.firstAvailableDate OR TaskCardInfo.startAt (which are the same value)
// dueDate: TaskResult.dueDate OR TaskCardInfo.dueAt
const getActivityDatesMetadata = (patientPreferredTimeZone, activityInstance, taskData, appointmentStartAt) => {
    const { activityStartDate, activityStartTime, dataCollectionStartDate, dataCollectionStartTime, dataCollectionEndDate, dataCollectionEndTime, activityTranscribedDate, } = activityInstance ?? {};
    const isTranscribed = !!activityTranscribedDate;
    const patientTimeZoneOffset = (0, datetime_1.formatDate)('Z', new Date(), null, patientPreferredTimeZone);
    const patientTimeZoneZeroTime = `00:00:00.000${patientTimeZoneOffset}`;
    const dateTimeToDateWithTZ = (dateTime) => (0, datetime_1.formatDate)(dateConstants_1.normalizedDateFormat, dateTime, null, patientPreferredTimeZone);
    const dates = {};
    if (appointmentStartAt) {
        const fullDateTime = appointmentStartAt;
        dates[validation_1.ValidationMetadataEnum.VISIT_START_DATETIME] = fullDateTime;
        dates[validation_1.ValidationMetadataEnum.VISIT_START_DATE] = dateTimeToDateWithTZ(fullDateTime);
    }
    if (isTranscribed && dataCollectionStartDate) {
        const fullDateTime = dataCollectionStartTime
            ? `${dataCollectionStartDate}T${dataCollectionStartTime}`
            : `${dataCollectionStartDate}T${patientTimeZoneZeroTime}`;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATETIME] = fullDateTime;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATE] = dateTimeToDateWithTZ(fullDateTime);
    }
    else if (isTranscribed && dataCollectionEndDate) {
        // Home Transcription asks only for collection completion (end) date
        const fullDateTime = dataCollectionEndTime
            ? `${dataCollectionEndDate}T${dataCollectionEndTime}`
            : `${dataCollectionEndDate}T${patientTimeZoneZeroTime}`;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATETIME] = fullDateTime;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATE] = dateTimeToDateWithTZ(fullDateTime);
    }
    else if (activityStartDate) {
        const fullDateTime = `${activityStartDate}T${activityStartTime}`;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATETIME] = fullDateTime;
        dates[validation_1.ValidationMetadataEnum.ACTIVITY_START_DATE] = dateTimeToDateWithTZ(fullDateTime);
    }
    if (!taskData?.isEpisodic) {
        if (taskData?.firstAvailableDate) {
            const fullDateTime = taskData.firstAvailableDate;
            dates[validation_1.ValidationMetadataEnum.TASK_START_DATETIME] = fullDateTime;
            dates[validation_1.ValidationMetadataEnum.TASK_START_DATE] = dateTimeToDateWithTZ(fullDateTime);
        }
        if (taskData?.dueDate) {
            const fullDateTime = taskData.dueDate;
            dates[validation_1.ValidationMetadataEnum.TASK_END_DATETIME] = fullDateTime;
            dates[validation_1.ValidationMetadataEnum.TASK_END_DATE] = dateTimeToDateWithTZ(fullDateTime);
        }
    }
    return dates;
};
exports.getActivityDatesMetadata = getActivityDatesMetadata;
const getRulesEngineDPIAnswers = (activityDataPointInstanceAnswers) => {
    const extraFacts = {};
    Object.entries(activityDataPointInstanceAnswers || {}).forEach(([dataPointId, dpi]) => {
        // Wrap so that the path to the answer matches the configured one in validations
        // which is wrapped by 'normalizedValues' object
        extraFacts[dataPointId] = { normalizedValues: dpi };
    });
    return extraFacts;
};
exports.getRulesEngineDPIAnswers = getRulesEngineDPIAnswers;
const getActivityRulesEngineExtraFacts = (activityDataPointInstanceAnswers, patientPreferredTimeZone, activityInstance, taskData, appointmentStartAt) => {
    const dpiAnswers = (0, exports.getRulesEngineDPIAnswers)(activityDataPointInstanceAnswers);
    const datesMetadata = (0, exports.getActivityDatesMetadata)(patientPreferredTimeZone, activityInstance, taskData, appointmentStartAt);
    return { ...dpiAnswers, ...datesMetadata };
};
exports.getActivityRulesEngineExtraFacts = getActivityRulesEngineExtraFacts;
